import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { getPiiServiceId } from '../../../../../shared/pii/pii.utils';
import {
  ApplicationState,
  getSelectedProductDetails,
} from '../../../../../store/reducers';
import { GetProductDetails } from '../../../../../store/actions/product-details.actions';
import { Store } from '@ngrx/store';
import {
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-internet-settings-pxsplus',
  templateUrl: './internet-settings-pxsplus.component.html',
})
export class InternetSettingsPxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  userId: string;
  selectedProduct: any;
  hasError = false;

  constructor(
    private store: Store<ApplicationState>,
    private route: ActivatedRoute,
    private pxModalMessageService: PxModalMessageService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadInternetDetails();
  }

  private loadInternetDetails() {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value) {
            if (value?.internetProductDetails) {
              this.selectedProduct = value?.internetProductDetails;
            }
          }
        }),
      );
      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'internet',
              serviceId,
            }),
          );
        }),
      );
    } else {
      this.hasError = true;
      this.pxModalMessageService.dispatchMessage(
        MessageType.Error,
        LevelType.Root,
        this.translationService.getTranslatedValueFor(
          'message.error.internet.settings.description',
        ),
        this.translationService.getTranslatedValueFor('message.error.title'),
        false,
        false,
        'technicalError',
      );
    }
  }
}
